import type { MutationKey } from "@tanstack/react-query"

enum EAuthMutationKeyBase {
    Login = "Auth.Login",
    Pass = "Auth.Password",
    SSO = "Auth.SSO"
}

const EMutationKey: {
    Login(): MutationKey
    Pass(key: string): MutationKey
    SSO(): MutationKey
} = {
    Login: (): MutationKey => [EAuthMutationKeyBase.Login],
    Pass: (key: string): MutationKey => [EAuthMutationKeyBase.Pass, key],
    SSO: (): MutationKey => [EAuthMutationKeyBase.SSO]
} as const

const EMutationUrl: { Login(): string; Pass(key: string): string; SSO(): string } = {
    Login: (): string => "/api/user/login/",
    Pass: (key: string): string => `/api/user/set-password/${key}/`,
    SSO: (): string => "/api/user/org-sso/"
} as const

export { EMutationKey as EAuthMutationKey, EMutationUrl as EAuthMutationUrl, EAuthMutationKeyBase }
